import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const formatSignedPoint = (value) => {
    const numericValue = Number(value || 0);
    const sign = numericValue > 0 ? '+' : '';
    return `${sign}${numericValue.toLocaleString()}`;
};

function RoomUserSP(props) {
    const user = props.user;
    const index = props.index;

    const getTableRowStyle = (index) => {
        if (index === 0) return { backgroundColor: "Gold" };
        if (index === 1) return { backgroundColor: "silver" };
        if (index === 2) return { backgroundColor: "rgb(196 112 34)" };
        return { backgroundColor: "rgb(196 112 34)" };
    };
      
    const getTableCellStyle = () => {
        return {
            padding: '6px 8px',
            fontSize: '12px',
            color: '#333',
            textAlign: 'center',
            border: '1px solid rgba(224, 224, 224, 1)',
        };
    };

    return (
        <TableRow
            onClick={() => props.onClick()}
            style={getTableRowStyle(index)}>
            <TableCell style={{ ...getTableCellStyle(), width: '28px' }}>
            {user.rank === 999 ? '-' : user.rank}
            </TableCell>
            <TableCell style={{ ...getTableCellStyle(), minWidth: '60px', maxWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user.name}</TableCell>
            <TableCell style={{ ...getTableCellStyle(), width: '40px' }}>{formatSignedPoint(user.balance)}</TableCell>
            <TableCell style={{ ...getTableCellStyle(), width: '36px' }}>{user.winRate}</TableCell>
        </TableRow>
    );
}
export default RoomUserSP;
